import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AgencyService } from '../agency.service';
import { ClientService } from '../client.service';
import { SpinnerService } from '../../core';
import { emailValidator, phoneNumberValidator, zipCodeValidator } from '../../shared';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Message } from 'primeng/components/common/api';

@Component({
  selector: 'app-agency',
  templateUrl: './agency.component.html',
  styleUrls: ['./agency.component.css']
})
export class AgencyComponent implements OnInit {
  msgs: Message[] = [];

  agencyForm: FormGroup;
  editAgency = false;
  btnShow:string='none';
  allAgenciesObject: any;
  allAgenciesObjectCount: any;
  usDateValue: any;
  formattedNumber: any;
  area: any;
  front: any;
  end: any;
  c: any;
  states = [];
  redError = 'red';
  agency_nameError = 'none';
  agency_web_siteError = 'none';
  agency_main_phoneError = 'none';
  agency_main_faxError = 'none';
  physical_addressError = 'none';
  physical_cityError = 'none';
  physical_stateError = 'none';
  physical_zipError = 'none';
  mailing_addressError = 'none';
  mailing_cityError = 'none';
  mailing_stateError = 'none';
  mailing_zipError = 'none';
  contact_1_nameError = 'none';
  contact_1_roleError = 'none';
  contact_1_phoneError = 'none';
  contact_2_phoneError = 'none';
  contact_3_phoneError = 'none';
  contact_4_phoneError = 'none';
  contact_5_phoneError = 'none';
  contact_6_phoneError = 'none';
  contact_7_phoneError = 'none';
  contact_8_phoneError = 'none';
  contact_9_phoneError = 'none';
  contact_10_phoneError = 'none';
  contact_1_emailError = 'none';
  contact_2_emailError = 'none';
  contact_3_emailError = 'none';
  contact_4_emailError = 'none';
  contact_5_emailError = 'none';
  contact_6_emailError = 'none';
  contact_7_emailError = 'none';
  contact_8_emailError = 'none';
  contact_9_emailError = 'none';
  contact_10_emailError = 'none';
  agency_notesError = 'none';
  agency_main_phoneError_message = "";
  physical_zipError_message = "";
  mailing_zipError_message = "";
  contact_1_phoneError_message = "";
  contact_2_phoneError_message = "";
  contact_3_phoneError_message = "";
  contact_4_phoneError_message = "";
  contact_5_phoneError_message = "";
  contact_6_phoneError_message = "";
  contact_7_phoneError_message = "";
  contact_8_phoneError_message = "";
  contact_9_phoneError_message = "";
  contact_10_phoneError_message = "";
  contact_1_emailError_message = "";
  contact_2_emailError_message = "";
  contact_3_emailError_message = "";
  contact_4_emailError_message = "";
  contact_5_emailError_message = "";
  contact_6_emailError_message = "";
  contact_7_emailError_message = "";
  contact_8_emailError_message = "";
  contact_9_emailError_message = "";
  contact_10_emailError_message = "";
  skip: any;
  take: any;
  searchVal: any;
  filteredStates: any[];
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private agencyService: AgencyService,
    private spinnerService: SpinnerService,
    private clientService: ClientService
  ) { }

  showResetForm()
  {
    this.agencyForm.reset();
    this.editAgency=true;
  }

  scrollTo(className: string): void {
    setTimeout(function () {
      const elementList = document.querySelectorAll('.' + className);
      const element = elementList[0] as HTMLElement;
      element.scrollIntoView({ behavior: 'smooth' });
    }, 1000);
  }
  
  feleFocus()
  {
    this.btnShow = 'block';
  }
  
  ngOnInit() {
    this.agencyForm = this.formBuilder.group({
      agency_name: ['', Validators.required],
      agency_web_site: '',
      agency_main_phone: '',
      agency_main_fax: '',
      physical_address: '',
      physical_city: '',
      physical_state: '',
      physical_zip: '',
      mailing_address: '',
      mailing_city: '',
      mailing_state: '',
      mailing_zip: '',
      contact_1_name: '',
      contact_1_role: '',
      contact_1_phone: '',
      contact_1_email: '',
      contact_2_name: '',
      contact_2_role: '',
      contact_2_phone: '',
      contact_2_email: '',
      contact_3_name: '',
      contact_3_role: '',
      contact_3_phone: '',
      contact_3_email: '',
      contact_4_name: '',
      contact_4_role: '',
      contact_4_phone: '',
      contact_4_email: '',
      contact_5_name: '',
      contact_5_role: '',
      contact_5_phone: '',
      contact_5_email: '',
      contact_6_name: '',
      contact_6_role: '',
      contact_6_phone: '',
      contact_6_email: '',
      contact_7_name: '',
      contact_7_role: '',
      contact_7_phone: '',
      contact_7_email: '',
      contact_8_name: '',
      contact_8_role: '',
      contact_8_phone: '',
      contact_8_email: '',
      contact_9_name: '',
      contact_9_role: '',
      contact_9_phone: '',
      contact_9_email: '',
      contact_10_name: '',
      contact_10_role: '',
      contact_10_phone: '',
      contact_10_email: '',
      agency_notes: ''
    });
    // get states
    this.clientService.getStates().subscribe(res => {
      this.states = res;
      this.states.unshift({ label: 'Select', value: '' });
    });
    //Get All Agenceies
    this.skip = 0;
    this.take = 12;
    this.searchVal = '';
    this.getAll();

  }
  getAll() {
    this.agencyService.getAllAgencies(this.skip, this.take, this.searchVal).subscribe(response => {
      this.allAgenciesObject = response[1];
      this.allAgenciesObjectCount = response[0];
      this.spinnerService.hide();
    });
  }
  loadData(event) {
    this.skip = event.first;
    this.take = event.rows;
    this.getAll();
  }
  search(event) {
    this.searchVal = event.target.value;
    this.skip = 0;
    this.take = 12;
    this.getAll();
  }
  // Hide All Errors in the popup 
  hideAllErrors() {

    this.btnShow='none';

    this.agency_nameError = 'none';
    this.agency_web_siteError = 'none';
    this.agency_main_phoneError = 'none';
    this.agency_main_faxError = 'none';
    this.physical_addressError = 'none';
    this.physical_cityError = 'none';
    this.physical_stateError = 'none';
    this.physical_zipError = 'none';
    this.mailing_addressError = 'none';
    this.mailing_cityError = 'none';
    this.mailing_stateError = 'none';
    this.mailing_zipError = 'none';
    this.contact_1_nameError = 'none';
    this.contact_1_roleError = 'none';
    this.contact_1_phoneError = 'none';
    this.contact_2_phoneError = 'none';
    this.contact_3_phoneError = 'none';
    this.contact_4_phoneError = 'none';
    this.contact_5_phoneError = 'none';
    this.contact_6_phoneError = 'none';
    this.contact_7_phoneError = 'none';
    this.contact_8_phoneError = 'none';
    this.contact_9_phoneError = 'none';
    this.contact_10_phoneError = 'none';
    this.contact_1_emailError = 'none';
    this.contact_2_emailError = 'none';
    this.contact_3_emailError = 'none';
    this.contact_4_emailError = 'none';
    this.contact_5_emailError = 'none';
    this.contact_6_emailError = 'none';
    this.contact_7_emailError = 'none';
    this.contact_8_emailError = 'none';
    this.contact_9_emailError = 'none';
    this.contact_10_emailError = 'none';
    this.contact_1_phoneError_message = "";
    this.contact_2_phoneError_message = "";
    this.contact_3_phoneError_message = "";
    this.contact_4_phoneError_message = "";
    this.contact_5_phoneError_message = "";
    this.contact_6_phoneError_message = "";
    this.contact_7_phoneError_message = "";
    this.contact_8_phoneError_message = "";
    this.contact_9_phoneError_message = "";
    this.contact_10_phoneError_message = "";
    this.contact_1_emailError_message = "";
    this.contact_2_emailError_message = "";
    this.contact_3_emailError_message = "";
    this.contact_4_emailError_message = "";
    this.contact_5_emailError_message = "";
    this.contact_6_emailError_message = "";
    this.contact_7_emailError_message = "";
    this.contact_8_emailError_message = "";
    this.contact_9_emailError_message = "";
    this.contact_10_emailError_message = "";
    this.agency_notesError = 'none';
    this.agency_main_phoneError_message = "";
    this.physical_zipError_message = "";
    this.mailing_zipError_message = "";
  }

  usFormattedFax() {
    this.usDateValue = this.agencyForm.value.agency_main_fax;
    this.formattedNumber = String(this.usDateValue.replace(/[- )(]/g, ''));
    // # (###) ###-#### as c (area) front-end
    this.area = this.formattedNumber.substring(0, 3);
    this.front = this.formattedNumber.substring(3, 6);
    this.end = this.formattedNumber.substring(6, this.formattedNumber.length);
    if (this.front) {
      this.formattedNumber = ("(" + this.area + ") " + this.front);
    }
    if (this.end) {
      this.formattedNumber += ("-" + this.end);
    }
    this.agencyForm.controls['agency_main_fax'].setValue(this.formattedNumber);
  }

  submitAgencyForm() {
    if (this.agencyForm.valid) {
      this.agency_nameError = 'none';
      var validateFlag = 0;
      if (this.agencyForm.value.agency_main_phone == '' || this.agencyForm.value.agency_main_phone == null) {
        // this.agency_main_phoneError = 'block';
        // this.agency_main_phoneError_message = 'Required';
      } else {
      }

      if (this.agencyForm.value.physical_zip == '' || this.agencyForm.value.physical_zip == null) {
        // this.physical_zipError = 'block';
        // this.physical_zipError_message = 'Required.';
      } else {
        const pattern = /^[0-9=]*$/;
        if (!this.agencyForm.value.physical_zip.match(pattern)) {
          this.physical_zipError = 'block';
          this.physical_zipError_message = 'Zip Code is not valid.';
          validateFlag = 1;
        } else {
          this.physical_zipError = 'none';
        }
      }

      if (this.agencyForm.value.mailing_zip == '' || this.agencyForm.value.mailing_zip == null) {
        // this.mailing_zipError = 'block';
        // this.mailing_zipError_message = 'Required.';
      } else {
        const pattern = /^[0-9=]*$/;
        if (!this.agencyForm.value.mailing_zip.match(pattern)) {
          this.mailing_zipError = 'block';
          this.mailing_zipError_message = 'Zip Code is not valid.';
          validateFlag = 1;
        } else {
          this.mailing_zipError = 'none';
        }
      }

      if (this.agencyForm.value.contact_1_phone == '' || this.agencyForm.value.contact_1_phone == null) {
        // this.contact_1_phoneError = 'block';
        // this.contact_1_phoneError_message = 'Required';
      } else {
      }

      if (this.agencyForm.value.contact_1_email == '' || this.agencyForm.value.contact_1_email == null) {
        // this.contact_1_emailError = 'block';
        // this.contact_1_emailError_message = 'Required';
      } else {
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!EMAIL_REGEXP.test(this.agencyForm.value.contact_1_email)) {
          this.contact_1_emailError = 'block';
          this.contact_1_emailError_message = 'Email Format is not valid.';
          validateFlag = 1;
        } else {
          this.contact_1_emailError = 'none';
        }
      }

      if (this.agencyForm.value.contact_2_phone == '' || this.agencyForm.value.contact_2_phone == null) {
        // this.contact_2_phoneError = 'block';
        // this.contact_2_phoneError_message = 'Required';
      } else {
      }

      if (this.agencyForm.value.contact_2_email == '' || this.agencyForm.value.contact_2_email == null) {
        // this.contact_2_emailError = 'block';
        // this.contact_2_emailError_message = 'Required';
      } else {
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!EMAIL_REGEXP.test(this.agencyForm.value.contact_2_email)) {
          this.contact_2_emailError = 'block';
          this.contact_2_emailError_message = 'Email Format is not valid.';
          validateFlag = 1;
        } else {
          this.contact_2_emailError = 'none';
        }
      }

      if (this.agencyForm.value.contact_3_phone == '' || this.agencyForm.value.contact_3_phone == null) {
        // this.contact_3_phoneError = 'block';
        // this.contact_3_phoneError_message = 'Required';
      } else {
      }

      if (this.agencyForm.value.contact_3_email == '' || this.agencyForm.value.contact_3_email == null) {
        // this.contact_3_emailError = 'block';
        // this.contact_3_emailError_message = 'Required';
      } else {
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!EMAIL_REGEXP.test(this.agencyForm.value.contact_3_email)) {
          this.contact_3_emailError = 'block';
          this.contact_3_emailError_message = 'Email Format is not valid.';
          validateFlag = 1;
        } else {
          this.contact_3_emailError = 'none';
        }
      }

      if (this.agencyForm.value.contact_4_phone == '' || this.agencyForm.value.contact_4_phone == null) {
        // this.contact_4_phoneError = 'block';
        // this.contact_4_phoneError_message = 'Required';
      } else {
      }

      if (this.agencyForm.value.contact_4_email == '' || this.agencyForm.value.contact_4_email == null) {
        // this.contact_4_emailError = 'block';
        // this.contact_4_emailError_message = 'Required';
      } else {
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!EMAIL_REGEXP.test(this.agencyForm.value.contact_4_email)) {
          this.contact_4_emailError = 'block';
          this.contact_4_emailError_message = 'Email Format is not valid.';
          validateFlag = 1;
        } else {
          this.contact_4_emailError = 'none';
        }
      }

      if (this.agencyForm.value.contact_5_phone == '' || this.agencyForm.value.contact_5_phone == null)
	  {
        // this.contact_5_phoneError = 'block';
        // this.contact_5_phoneError_message = 'Required';
      }
	  else
	  {
    }

      if (this.agencyForm.value.contact_5_email == '' || this.agencyForm.value.contact_5_email == null) {
        // this.contact_5_emailError = 'block';
        // this.contact_5_emailError_message = 'Required';
      }
	  else
	  {
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!EMAIL_REGEXP.test(this.agencyForm.value.contact_5_email)) {
          this.contact_5_emailError = 'block';
          this.contact_5_emailError_message = 'Email Format is not valid.';
          validateFlag = 1;
        } else {
          this.contact_5_emailError = 'none';
        }
    }

    if (this.agencyForm.value.contact_6_phone == '' || this.agencyForm.value.contact_6_phone == null)
	  {
        // this.contact_6_phoneError = 'block';
        // this.contact_6_phoneError_message = 'Required';
      }
	  else
	  {
      }

      if (this.agencyForm.value.contact_6_email == '' || this.agencyForm.value.contact_6_email == null) {
        // this.contact_6_emailError = 'block';
        // this.contact_6_emailError_message = 'Required';
      }
	  else
	  {
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!EMAIL_REGEXP.test(this.agencyForm.value.contact_6_email)) {
          this.contact_6_emailError = 'block';
          this.contact_6_emailError_message = 'Email Format is not valid.';
          validateFlag = 1;
        } else {
          this.contact_6_emailError = 'none';
        }
      }
    

      if (this.agencyForm.value.contact_7_phone == '' || this.agencyForm.value.contact_7_phone == null)
	  {
        // this.contact_7_phoneError = 'block';
        // this.contact_7_phoneError_message = 'Required';
      }
	  else
	  {
    }

      if (this.agencyForm.value.contact_7_email == '' || this.agencyForm.value.contact_7_email == null) {
        // this.contact_7_emailError = 'block';
        // this.contact_7_emailError_message = 'Required';
      }
	  else
	  {
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!EMAIL_REGEXP.test(this.agencyForm.value.contact_7_email)) {
          this.contact_7_emailError = 'block';
          this.contact_7_emailError_message = 'Email Format is not valid.';
          validateFlag = 1;
        } else {
          this.contact_7_emailError = 'none';
        }
      }


      if (this.agencyForm.value.contact_8_phone == '' || this.agencyForm.value.contact_8_phone == null)
	  {
        // this.contact_8_phoneError = 'block';
        // this.contact_8_phoneError_message = 'Required';
      }
	  else
	  {
    }

      if (this.agencyForm.value.contact_8_email == '' || this.agencyForm.value.contact_8_email == null) {
        // this.contact_8_emailError = 'block';
        // this.contact_8_emailError_message = 'Required';
      }
	  else
	  {
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!EMAIL_REGEXP.test(this.agencyForm.value.contact_8_email)) {
          this.contact_8_emailError = 'block';
          this.contact_8_emailError_message = 'Email Format is not valid.';
          validateFlag = 1;
        } else {
          this.contact_8_emailError = 'none';
        }
      }


      if (this.agencyForm.value.contact_9_phone == '' || this.agencyForm.value.contact_9_phone == null)
	  {
        // this.contact_9_phoneError = 'block';
        // this.contact_9_phoneError_message = 'Required';
      }
	  else
	  {
    }

      if (this.agencyForm.value.contact_9_email == '' || this.agencyForm.value.contact_9_email == null) {
        // this.contact_9_emailError = 'block';
        // this.contact_9_emailError_message = 'Required';
      }
	  else
	  {
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!EMAIL_REGEXP.test(this.agencyForm.value.contact_9_email)) {
          this.contact_9_emailError = 'block';
          this.contact_9_emailError_message = 'Email Format is not valid.';
          validateFlag = 1;
        } else {
          this.contact_9_emailError = 'none';
        }
      }
      

      if (this.agencyForm.value.contact_10_phone == '' || this.agencyForm.value.contact_10_phone == null)
	  {
        // this.contact_10_phoneError = 'block';
        // this.contact_10_phoneError_message = 'Required';
      }
	  else
	  {
    }

      if (this.agencyForm.value.contact_10_email == '' || this.agencyForm.value.contact_10_email == null) {
        // this.contact_10_emailError = 'block';
        // this.contact_10_emailError_message = 'Required';
      }
	  else
	  {
        const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!EMAIL_REGEXP.test(this.agencyForm.value.contact_10_email)) {
          this.contact_10_emailError = 'block';
          this.contact_10_emailError_message = 'Email Format is not valid.';
          validateFlag = 1;
        } else {
          this.contact_10_emailError = 'none';
        }
      }


      if (validateFlag == 0) {
        var agencyFormObject = this.agencyForm.value;
        // console.log(agencyFormObject);
        this.agencyService.addAgency(agencyFormObject).subscribe(response => {
          this.editAgency = false;
          this.skip = 0;
          this.take = 12;
          this.searchVal = '';
          this.getAll();
        });
      }

    } else {
      if (this.agencyForm.value.agency_name == '' || this.agencyForm.value.agency_name == null) {
        this.agency_nameError = 'block';
      } else {
        this.agency_nameError = 'none';
      }
      // if (this.agencyForm.value.agency_web_site == '' || this.agencyForm.value.agency_web_site == null) {
      //   this.agency_web_siteError = 'block';
      // } else {
      //   this.agency_web_siteError = 'none';
      // }
      // if (this.agencyForm.value.agency_main_phone == '' || this.agencyForm.value.agency_main_phone == null) {
      //   this.agency_main_phoneError = 'block';
      //   this.agency_main_phoneError_message = 'Required';
      // } else {
      //   const pattern1 = /^\d{10}$/;
      //   //const pattern2 = /^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/;
      //   const pattern2 = /^\(?(\d{3})\)?[-\. ]?(\d{3})[-\. ]?(\d{4})$/;

      //   if (!this.agencyForm.value.agency_main_phone.match(pattern1) && !this.agencyForm.value.agency_main_phone.match(pattern2)) {
      //     this.agency_main_phoneError = 'block';
      //     this.agency_main_phoneError_message = 'Format allow  (xxx)-xxx-xxxx';
      //   } else {
      //     this.agency_main_phoneError = 'none';
      //   }
      // }
      // if (this.agencyForm.value.agency_main_fax == '' || this.agencyForm.value.agency_main_fax == null) {
      //   this.agency_main_faxError = 'block';
      // } else {
      //   this.agency_main_faxError = 'none';
      // }
      // if (this.agencyForm.value.physical_address == '' || this.agencyForm.value.physical_address == null) {
      //   this.physical_addressError = 'block';
      // } else {
      //   this.physical_addressError = 'none';
      // }

      // if (this.agencyForm.value.physical_city == '' || this.agencyForm.value.physical_city == null) {
      //   this.physical_cityError = 'block';
      // } else {
      //   this.physical_cityError = 'none';
      // }
      // if (this.agencyForm.value.physical_state == '' || this.agencyForm.value.physical_state == null) {
      //   this.physical_stateError = 'block';
      // } else {
      //   this.physical_stateError = 'none';
      // }
      // if (this.agencyForm.value.physical_zip == '' || this.agencyForm.value.physical_zip == null) {
      //   this.physical_zipError = 'block';
      //   this.physical_zipError_message = 'Required.';
      // } else {
      //   const pattern = /^[0-9=]*$/;
      //   if (!this.agencyForm.value.physical_zip.match(pattern)) {
      //     this.physical_zipError = 'block';
      //     this.physical_zipError_message = 'Zip Code is not valid.';
      //   } else {
      //     this.physical_zipError = 'none';
      //   }
      // }

      // if (this.agencyForm.value.mailing_address == '' || this.agencyForm.value.mailing_address == null) {
      //   this.mailing_addressError = 'block';
      // } else {
      //   this.mailing_addressError = 'none';
      // }

      // if (this.agencyForm.value.mailing_city == '' || this.agencyForm.value.mailing_city == null) {
      //   this.mailing_cityError = 'block';
      // } else {
      //   this.mailing_cityError = 'none';
      // }
      // if (this.agencyForm.value.mailing_state == '' || this.agencyForm.value.mailing_state == null) {
      //   this.mailing_stateError = 'block';
      // } else {
      //   this.mailing_stateError = 'none';
      // }
      // if (this.agencyForm.value.mailing_zip == '' || this.agencyForm.value.mailing_zip == null) {
      //   this.mailing_zipError = 'block';
      //   this.mailing_zipError_message = 'Required.';
      // } else {
      //   const pattern = /^[0-9=]*$/;
      //   if (!this.agencyForm.value.mailing_zip.match(pattern)) {
      //     this.mailing_zipError = 'block';
      //     this.mailing_zipError_message = 'Zip Code is not valid.';
      //   } else {
      //     this.mailing_zipError = 'none';
      //   }
      // }

      // if (this.agencyForm.value.contact_1_name == '' || this.agencyForm.value.contact_1_name == null) {
      //   this.contact_1_nameError = 'block';
      // } else {
      //   this.contact_1_nameError = 'none';
      // }

      // if (this.agencyForm.value.contact_1_role == '' || this.agencyForm.value.contact_1_role == null) {
      //   this.contact_1_roleError = 'block';
      // } else {
      //   this.contact_1_roleError = 'none';
      // }

      // if (this.agencyForm.value.contact_1_phone == '' || this.agencyForm.value.contact_1_phone == null) {
      //   this.contact_1_phoneError = 'block';
      //   this.contact_1_phoneError_message = 'Required';
      // } else {
      //   const pattern1 = /^\d{10}$/;
      //   const pattern2 = /^\(?(\d{3})\)?[-\. ]?(\d{3})[-\. ]?(\d{4})$/;
      //   if (!this.agencyForm.value.contact_1_phone.match(pattern1) && !this.agencyForm.value.contact_1_phone.match(pattern2)) {
      //     this.contact_1_phoneError = 'block';
      //     this.contact_1_phoneError_message = 'Format allow (xxx)-xxx-xxxx';
      //   } else {
      //     this.contact_1_phoneError = 'none';
      //   }
      // }

      // if (this.agencyForm.value.contact_1_email == '' || this.agencyForm.value.contact_1_email == null) {
      //   this.contact_1_emailError = 'block';
      //   this.contact_1_emailError_message = 'Required';
      // } else {
      //   const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //   if (!EMAIL_REGEXP.test(this.agencyForm.value.contact_1_email)) {
      //     this.contact_1_emailError = 'block';
      //     this.contact_1_emailError_message = 'Email Format is not valid.';
      //   } else {
      //     this.contact_1_emailError = 'none';
      //   }
      // }
      // if (this.agencyForm.value.agency_notes == '' || this.agencyForm.value.agency_notes == null) {
      //   this.agency_notesError = 'block';
      // } else {
      //   this.agency_notesError = 'none';
      // }
    }
  }

 
  usFormatteddate(phonenumbrerlabel) {
    if (phonenumbrerlabel == 1) {
      this.usDateValue = this.agencyForm.value.agency_main_phone;
    } else if (phonenumbrerlabel == 2) {
      this.usDateValue = this.agencyForm.value.contact_1_phone;
    } else if (phonenumbrerlabel == 3) {
      this.usDateValue = this.agencyForm.value.contact_2_phone;
    } else if (phonenumbrerlabel == 4) {
      this.usDateValue = this.agencyForm.value.contact_3_phone;
    } else if (phonenumbrerlabel == 5) {
      this.usDateValue = this.agencyForm.value.contact_4_phone;
    }
    else if (phonenumbrerlabel == 6)
    {
      this.usDateValue = this.agencyForm.value.contact_5_phone;
    }
    else if (phonenumbrerlabel == 7)
    {
      this.usDateValue = this.agencyForm.value.contact_6_phone;
    }else if (phonenumbrerlabel == 8)
    {
      this.usDateValue = this.agencyForm.value.contact_7_phone;
    }else if (phonenumbrerlabel == 9)
    {
      this.usDateValue = this.agencyForm.value.contact_8_phone;
    }else if (phonenumbrerlabel == 10)
    {
      this.usDateValue = this.agencyForm.value.contact_9_phone;
    }else if (phonenumbrerlabel == 11)
    {
      this.usDateValue = this.agencyForm.value.contact_10_phone;
    }

    this.formattedNumber = String(this.usDateValue.replace(/[- )(]/g, ''));
    //  this.c = (this.formattedNumber[0] == '1') ? '1 ' : '';
    //   this.formattedNumber = this.formattedNumber[0] == '1' ? this.formattedNumber.slice(1) : this.formattedNumber;

    // # (###) ###-#### as c (area) front-end
    this.area = this.formattedNumber.substring(0, 3);
    this.front = this.formattedNumber.substring(3, 6);
    this.end = this.formattedNumber.substring(6);

    if (this.front) {
      this.formattedNumber = ("(" + this.area + ") " + this.front);
    }
    if (this.end) {
      this.formattedNumber += ("-" + this.end);
    }

    // New Code for Ext Cleaned
    if( this.formattedNumber != undefined && this.formattedNumber != null )
    {
      var pContent = this.formattedNumber.toLowerCase().split( "ext" );
      var finalNum = "";
      if( typeof pContent !== 'undefined' && pContent.length )
      {
        if( typeof pContent[0] !== 'undefined' )
        {
          finalNum = pContent[0];
        }
        if( typeof pContent[1] !== 'undefined' )
        {
          finalNum += " Ext " + pContent[1];
        }
        this.formattedNumber = finalNum;
      }
    }


    if (phonenumbrerlabel == 1) {
      this.agencyForm.controls['agency_main_phone'].setValue(this.formattedNumber);
    } else if (phonenumbrerlabel == 2) {
      this.agencyForm.controls['contact_1_phone'].setValue(this.formattedNumber);
    } else if (phonenumbrerlabel == 3) {
      this.agencyForm.controls['contact_2_phone'].setValue(this.formattedNumber);
    } else if (phonenumbrerlabel == 4) {
      this.agencyForm.controls['contact_3_phone'].setValue(this.formattedNumber);
    } else if (phonenumbrerlabel == 5) {
      this.agencyForm.controls['contact_4_phone'].setValue(this.formattedNumber);
    }
    else if (phonenumbrerlabel == 6)
    {
      this.agencyForm.controls['contact_5_phone'].setValue(this.formattedNumber);
    }
    else if (phonenumbrerlabel == 7)
    {
      this.agencyForm.controls['contact_6_phone'].setValue(this.formattedNumber);
    }
    else if (phonenumbrerlabel == 8)
    {
      this.agencyForm.controls['contact_7_phone'].setValue(this.formattedNumber);
    }
    else if (phonenumbrerlabel == 9)
    {
      this.agencyForm.controls['contact_8_phone'].setValue(this.formattedNumber);
    }
    else if (phonenumbrerlabel == 10)
    {
      this.agencyForm.controls['contact_9_phone'].setValue(this.formattedNumber);
    }
    else if (phonenumbrerlabel == 11)
    {
      this.agencyForm.controls['contact_10_phone'].setValue(this.formattedNumber);
    }

  }
  filterStates(event) {
    this.filteredStates = [];
    for (let i = 0; i < this.states.length; i++) {
      let s = this.states[i].value;
      if (s.toLowerCase().indexOf(event.query.toLowerCase()) == 0) {
        this.filteredStates.push(s);
      }
    }
  }
}
